import styled from 'styled-components';

export const OpenMarketDescription = () => {
  return (
    <Container>
      <TitleSection>
        <Title>{'회원 직거래가 뭔가요?'}</Title>
        <Description>
          {'플루바 마켓을 통해 내 트랙터를 올리거나\n다른 판매자의 매물을 직거래 할 수 있어요!'}
        </Description>
      </TitleSection>

      <BackgroundImage width="195" height="153" viewBox="0 0 195 153" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M172.5 31.756L162.71 20.376C149.44 4.946 125.56 4.946 112.29 20.376L103.71 30.346C102.93 31.256 102.5 32.416 102.5 33.606V106.756C102.5 109.516 104.74 111.756 107.5 111.756H120.03C121.59 111.756 123.05 112.476 124 113.716L135.84 129.176C142.9 138.386 157.2 136.866 162.16 126.376L163.97 128.436C172.59 138.226 188.71 133.636 190.88 120.776L191.12 119.336L194.54 123.346C202.89 133.136 218.84 129.076 221.49 116.486L222.49 111.766L172.5 31.756Z"
          fill="#E4E4ED"
        />
        <path
          d="M220.08 28.946L211.88 19.416C198.9 4.32602 175.66 3.93602 162.19 18.596L136.371 46.676C128.621 55.106 128.891 68.146 136.991 76.246C145.491 84.746 159.331 84.566 167.601 75.846L172.191 71.006C174.091 69.006 177.252 68.916 179.252 70.816L222.502 111.756V35.466C222.5 33.075 221.64 30.755 220.08 28.946Z"
          fill="#D5D5E3"
        />
        <path
          d="M82.5 119.326H72.5C66.98 119.326 62.5 114.846 62.5 109.326V34.326C62.5 31.566 64.74 29.326 67.5 29.326H87.5C90.26 29.326 92.5 31.566 92.5 34.326V109.326C92.5 114.856 88.02 119.326 82.5 119.326Z"
          fill="#E4E4ED"
        />
        <path
          d="M77.5 111.755C80.261 111.755 82.5 109.517 82.5 106.755C82.5 103.994 80.261 101.755 77.5 101.755C74.739 101.755 72.5 103.994 72.5 106.755C72.5 109.517 74.739 111.755 77.5 111.755Z"
          fill="#F2F2F7"
        />
      </BackgroundImage>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  padding: 40px var(--radius-large, 16px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);

  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const TitleSection = styled.div`
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-medium, 8px);
`;

const Title = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const Description = styled.pre`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const BackgroundImage = styled.svg`
  z-index: 1;
  position: absolute;
  right: 0px;
  height: 189px;
`;
